import { MessageCircle } from "lucide-react";

const WHATSAPP = "33776069799";

export default function WhatsAppFloat() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent("Bonjour Nova Clean Service, je souhaite avoir plus d'informations.")}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-28 right-6 z-40 group"
      aria-label="Contacter sur WhatsApp"
    >
      <div className="absolute inset-0 rounded-full bg-[#25D366] blur-xl opacity-50 group-hover:opacity-80 transition-opacity"></div>
      <div className="relative w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] flex items-center justify-center shadow-2xl border-2 border-white/20 transition-all group-hover:scale-110">
        <MessageCircle className="w-6 h-6 text-white" strokeWidth={2.5} />
      </div>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black/80 backdrop-blur-sm text-white text-xs font-semibold px-3 py-2 rounded opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity border border-white/10">
        WhatsApp direct
      </span>
    </a>
  );
}
